/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */
//Open with out Login
// import { FC, useEffect, useState } from 'react'
// import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
// import { PrivateRoutes } from './PrivateRoutes'
// import { ErrorsPage } from '../modules/errors/ErrorsPage'
// import { Logout, useAuth } from '../modules/auth'
// import { App } from '../App'
// import fetchAPI from '../../common/fetchAPI'
// import { useAppDispatch } from '../../app/hooks';
// import { getManageTerminologyAsync, getEmployeeProfileSettingAsync, getAccountFeatureAsync, getGlobalAccountPreferenceDataAsync } from '../../common/GlobalSlice';
// import { logOut } from '../../common/auth/Auth';
// import { Tooltip } from 'react-tooltip';
// import { InfoPage } from '../modules/info/InfoPage' 
// /**
//  * Base URL of the website.
//  *
//  * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
//  */
// const { REACT_APP_PUBLIC_URL, NODE_ENV } = process.env

// const AppRoutes: FC = () => {
//   const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
//   const [isApiCallDone, setIsApiCallDone] = useState<boolean>(false);
//   const dispatch = useAppDispatch();
//   useEffect(() => {
//     getIsAuthenticated();
//   }, []);
//   const validateAccessToken = async () => {
//     const response = await fetchAPI('Services/react.svc/IsAuthenticated', 'POST', "", false);
//     const json = await response.json();
//     let obj = json.hasOwnProperty("d") ? json.d : json;
//     if (!obj) {
//       //logOut();
//     }
//     else {
//       let accessToken: any = localStorage.getItem('accessToken');
//       let accountEmployeeId: any = localStorage.getItem('accountEmployeeId');
//       if (accessToken !== "" && accountEmployeeId !== 0) {
//         const response = await fetchAPI(`api/AccessToken/GetUpdatedAccessToken?AccessToken=${encodeURIComponent(accessToken)}&AccountEmployeeId=${encodeURIComponent(accountEmployeeId)}`, 'Get', '', true);
//         const json = await response.json();
//         localStorage.setItem('accessToken', json.DB);
//       }
//     }
//   };
//   const getIsAuthenticated = async () => {
//     if (NODE_ENV === 'development') {
//       dispatch(getEmployeeProfileSettingAsync()).then((employeeProfileSettingResult) => {
//         dispatch(getGlobalAccountPreferenceDataAsync()).then((result) => {
//           dispatch(getAccountFeatureAsync()).then((result) => {
//             dispatch(getManageTerminologyAsync());
//             setIsAuthenticated(true);
//           }).catch((error) => {
//           });
//         }).catch((error) => {
//         });
//       }).catch((error) => {
//       });
//     } else {
//       console.log = () => { }
//       console.error = () => { }
//       console.debug = () => { }
//       //localStorage.removeItem("accessToken");
//       //sessionStorage.removeItem("accessToken");
//       dispatch(getEmployeeProfileSettingAsync()).then((result) => {
//         dispatch(getGlobalAccountPreferenceDataAsync()).then((result) => {
//           dispatch(getAccountFeatureAsync()).then((result) => {
//             dispatch(getManageTerminologyAsync());
//             setIsAuthenticated(true);
//             validateAccessToken();
//             const interval = setInterval(() => {
//               validateAccessToken();
//             }, 10000); // 60000 milliseconds = 1 minute
//             return () => clearInterval(interval);
//           })
//         }).catch((error) => {
//         });
//       })
//     }
//     setIsApiCallDone(true);
//   }
//   if (!isApiCallDone) return (<span>loading...</span>);
//   return (
//     <BrowserRouter basename={REACT_APP_PUBLIC_URL}>
//       <Routes>
//         <Route element={<App />}>
//           <Route path='error/*' element={<ErrorsPage />} />
//           <Route path='info/*' element={<InfoPage />} />
//           <Route path='logout' element={<Logout />} />
//           {isAuthenticated ? (
//             <>
//               <Route path='/*' element={<PrivateRoutes />} />
//               <Route index element={<Navigate to='/timesheet' />} />
//               {/* <Route index element={<Navigate to='/timesheet' />} />
//               <Route index element={<Navigate to='/holidayTypeDetail' />} />
//               <Route index element={<Navigate to='/expensePolicyDetail' />} />
//               <Route index element={<Navigate to='/expensePolicyRule' />} />
//               <Route index element={<Navigate to='/ExpensePolicyPerDiem' />} />
//               <Route index element={<Navigate to='/ExpensePolicyLockingExpenses' />} />
//               <Route index element={<Navigate to='/AccountPreference' />} />
//               <Route index element={<Navigate to='/EmailNotificationPreference' />} />
//               <Route index element={<Navigate to='/ManageTerminology'/>} />
//               <Route index element={<Navigate to='/FeatureManagement'/>} />
//               <Route index element={<Navigate to='/PaidThrough'/>} />
//               <Route index element={<Navigate to='/PayCode'/>} />
//               <Route index element={<Navigate to='/PayRule'/>} />
//               <Route index element={<Navigate to='/AccountImportExport'/>} />
//               <Route index element={<Navigate to='/Expense'/>}/> */}
//             </>
//           ) : (
//             <>
//               <Route path="/" Component={() => { window.location.href = `${window.origin}?ReturnPage=/${REACT_APP_PUBLIC_URL}/`; return null }} />
//               {/* <Route path='auth/*' element={<AuthPage />} />
//              <Route path='*' element={<Navigate to='/auth' />} /> */}
//               {/* <Route path='/' element={window.location.href = "http://localhost:84/"} /> */}
//             </>
//           )}
//         </Route>
//       </Routes>
//       <Tooltip id="tooltip-Description" style={{ fontSize: 12, fontWeight: 'normal', padding: 8, borderRadius: 6, fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif' }} />
//     </BrowserRouter>
//   )
// }
// export { AppRoutes }
//Open with out Login


// /**
//  * High level router.
//  *
//  * Note: It's recommended to compose related routes in internal router
//  * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
//  */
//Open with Login
import { FC, useEffect, useState } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, useAuth, AuthPage } from '../modules/auth'
import { App } from '../App'
import fetchAPI from '../../common/fetchAPI'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  getManageTerminologyAsync, getEmployeeProfileSettingAsync, getAccountFeatureAsync, getGlobalAccountPreferenceDataAsync, updateEmployeeProfileSettingOnDev,
  GetCalendarEventsForNotification
} from '../../common/GlobalSlice';
import { getTimer } from '../../features/timesheet/timesheetSlice';
import { logOut } from '../../common/auth/Auth';
import { Tooltip } from 'react-tooltip';
import { InfoPage } from '../modules/info/InfoPage'
import { EmailAddressVerification } from '../modules/auth/components/EmailAddressVerification'
import { getLicenseActivationAndPageLoadDataAsync } from '../../features/admin/licenseActivation/LicenseActivationSlice'
import { updateLoadingEffect } from '../../features/admin/accountPreferences/accountPreferenceSlice'
import moment from 'moment'
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReminderToast from '../../features/calendar/ReminderToast'
import LivetecsAIWidget from '../../features/livetecsai/LivetecsAIWidget'
import { useRuntimeConfig } from '../../hooks/useRuntimeConfig'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { REACT_APP_PUBLIC_URL, NODE_ENV } = process.env

const AppRoutes: FC = () => {
  const { currentUser, auth } = useAuth()
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  // const [isApiCallDone, setIsApiCallDone] = useState<boolean>(false);
  const accessToken = localStorage.getItem('accessToken');
  const dispatch = useAppDispatch();
  //  const { isloading , isReload} = useAppSelector((state) => state.accountPreferences);
  const userRole = localStorage.getItem('userRole');
  const cleanStoredPage = (value: string | null) => {
    const page = value?.trim();
    return page && page !== 'null' && page !== 'undefined' ? page : null;
  };
  const userDefaultPage = cleanStoredPage(localStorage.getItem('systemCategoryPageFrontEnd'));
  const licenseExpireFlag = localStorage.getItem("IsLicenseExpired");
  const IsFreeLicenseExpired = localStorage.getItem("IsFreeLicenseExpired");
  const currentDate = moment().format('YYYY-MM-DD');
  const redirectAfterLogin = cleanStoredPage(localStorage.getItem('redirectAfterLogin'));
  const config = useRuntimeConfig();
  //  useEffect(() => {
  //   dispatch(getGlobalAccountPreferenceDataAsync())
  //   dispatch(updateLoadingEffect(false))
  // }, [isloading])

  useEffect(() => {
    accessToken != null && getIsAuthenticated();
  }, [currentUser]);

  const validateAccessToken = async () => {
    const response = await fetchAPI('Services/react.svc/IsAuthenticated', 'POST', "", false);
    const json = await response.json();
    let obj = json.hasOwnProperty("d") ? json.d : json;
    if (!obj) {
      //logOut();
    }
    else {
      let accessToken: any = localStorage.getItem('accessToken');
      let accountEmployeeId: any = localStorage.getItem('accountEmployeeId');
      if (accessToken !== "" && accountEmployeeId !== 0) {
        const response = await fetchAPI(`api/AccessToken/GetUpdatedAccessToken?AccessToken=${encodeURIComponent(accessToken)}&AccountEmployeeId=${encodeURIComponent(accountEmployeeId)}`, 'Get', '', true);
        const json = await response.json();
        localStorage.setItem('accessToken', json.DB);
      }
    }
  }

  const getIsAuthenticated = async () => {
    if (NODE_ENV === 'development') {
      //dispatch(getEmployeeProfileSettingAsync()).then((employeeProfileSettingResult) => {
      dispatch(updateEmployeeProfileSettingOnDev(auth));
      dispatch(getGlobalAccountPreferenceDataAsync()).then((result) => {
        dispatch(getLicenseActivationAndPageLoadDataAsync()).then((result) => {
          dispatch(getAccountFeatureAsync()).then((result) => {
            dispatch(getManageTerminologyAsync()).then((result) => {
              dispatch(getTimer());
              dispatch(GetCalendarEventsForNotification(currentDate))
              setIsAuthenticated(true);
            }).catch((error) => {
            });
          }).catch((error) => {
          });
        }).catch((error) => {
        });
      }).catch((error) => {
      });
      // }).catch((error) => {
      // });
    } else {
      console.log = () => { }
      console.error = () => { }
      console.debug = () => { }
      //localStorage.removeItem("accessToken");
      //sessionStorage.removeItem("accessToken");
      dispatch(updateEmployeeProfileSettingOnDev(auth));
      // // dispatch(getEmployeeProfileSettingAsync()).then((result) => {
      dispatch(getGlobalAccountPreferenceDataAsync()).then((result) => {
        dispatch(getLicenseActivationAndPageLoadDataAsync()).then((result) => {
          dispatch(getAccountFeatureAsync()).then((result) => {
            dispatch(getManageTerminologyAsync()).then((result) => {
              dispatch(getTimer());
              dispatch(GetCalendarEventsForNotification(currentDate))
              setIsAuthenticated(true);
              validateAccessToken();
              const interval = setInterval(() => {
                validateAccessToken();
              }, 10000); // 60000 milliseconds = 1 minute
              return () => clearInterval(interval);
            })
          })
        }).catch((error) => {
        });
      }).catch((error) => {
      });
    }
    // setIsApiCallDone(true);
  }

  useEffect(() => {
    const activeToasts = new Map<string, any>();
    const showFeedbackToast = () => {
      try {
        const notificationEvents = localStorage.getItem('Notification');
        if (!notificationEvents) {
          return;
        }

        const events = JSON.parse(notificationEvents);
        const currentTime = moment();

        events.forEach((e: any) => {
          const reminderTime = moment(e?.ScheduledNotificationTime);
          const eventStartTime = moment(e?.StartTime);
          const eventId = e?.CalendarEventId;
          if (currentTime.isSame(eventStartTime, 'minute')) {
            if (activeToasts.has(eventId)) {
              const toastId = activeToasts.get(eventId);
              toast.dismiss(toastId);
              activeToasts.delete(eventId);
            }
            dispatch(GetCalendarEventsForNotification(currentDate));
          }

          if (currentTime.isSame(reminderTime, 'minute')) {
            const toastId = toast(<ReminderToast eventData={e} />, {
              position: "bottom-right",
              autoClose: false,
              closeOnClick: false,
              hideProgressBar: true,
              draggable: false,
              closeButton: true,
              toastId: eventId,
              style: {
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                borderLeft: '4px solid #1e3a8a',
                minWidth: '300px'
              }
            });
            activeToasts.set(eventId, toastId);
          }
        });
      } catch (error) {
        console.error("Error in showFeedbackToast:", error);
      }
    };

    showFeedbackToast();
    const intervalId = setInterval(() => {
      showFeedbackToast();
    }, 60000);

    return () => {
      clearInterval(intervalId);
      activeToasts.forEach((toastId) => toast.dismiss(toastId));
    };
  }, [currentDate, dispatch]);
  // if (!isApiCallDone) return (<span>loading...</span>);
  return (
    <BrowserRouter >
      <ToastContainer
        position="bottom-right"
        newestOnTop
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
      />
      {/* <BrowserRouter basename={REACT_APP_PUBLIC_URL}> */}
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='info/*' element={<InfoPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path='emailaddressverification' element={<EmailAddressVerification />} />
          {/* {isAuthenticated ? ( */}
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              {/* by default timesheet page commet */}
              {/* <Route index element={<Navigate to='/timesheet' />} /> */}
              {(licenseExpireFlag === "true" || IsFreeLicenseExpired === "true") ? (
                <>
                  <Route index element={<Navigate to={'/expiry'} />} />
                </>
              ) : (
                <>
                  {redirectAfterLogin !== "" && redirectAfterLogin !== null ? (
                    <Route path='auth/*' element={<Navigate to={`/${redirectAfterLogin}`} />} />
                  ) : userDefaultPage !== "" && userDefaultPage !== null ? (
                    <Route path='auth/*' element={<Navigate to={`/${userDefaultPage}`} />} />
                  ) : userRole === "External User" ? (
                    <Route path='auth/*' element={<Navigate to='/timesheetapproval' />} />
                  ) : (
                    <Route index element={<Navigate to={(licenseExpireFlag === "true" || IsFreeLicenseExpired === "true") ? '/expiry' : '/dashboard'} />} />
                  )}
                  {/* {userDefaultPage !== "" && userDefaultPage !== null ? (
                    <Route path='auth/*' element={<Navigate to={`/${userDefaultPage}`} />} />
                  ) : userRole === "External User" ? (
                    <Route path='auth/*' element={<Navigate to='/timesheetapproval' />} />
                  ) : (
                    <Route index element={<Navigate to={(licenseExpireFlag === "true" || IsFreeLicenseExpired === "true") ? '/expiry' : '/dashboard'} />} />
                  )} */}
                </>
              )}
            </>
          ) : (
            <>
              {/* <Route path="/" Component={() => { window.location.href = `${window.origin}?ReturnPage=/${REACT_APP_PUBLIC_URL}/`; return null }} /> */}
              <Route path="/" Component={() => { window.location.href = `${window.origin}/auth`; return null }} />
              {/* <Route path="/" Component={() => { window.location.href = `${window.origin}/beta/auth`; return null }} /> */}
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
              {/* <Route path='/' element={window.location.href = "http://localhost:84/"} /> */}
            </>
          )}
        </Route>
      </Routes>
      {config?.IS_CHATBOT_AVAILABLE && accessToken != null && <LivetecsAIWidget />}
      <Tooltip id="tooltip-Description" style={{ fontSize: 12, fontWeight: 'normal', padding: 8, borderRadius: 6, fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif' }} />
    </BrowserRouter>
  )
}

export { AppRoutes }